
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.188.007C6.718.121 5.46.455 4.27 1.047 2.317 2.019.907 3.553.305 5.363-.07 6.49-.099 7.659.218 8.866a6.796 6.796 0 002.053 3.313l.215.187v.121c0 .298-.15.653-.38.895-.176.184-.313.267-.605.365-.348.118-.506.25-.642.537a1.031 1.031 0 00-.002.945c.254.53.853.768 1.934.769.408 0 .672-.023 1.018-.089 1.014-.193 1.98-.64 2.935-1.357l.236-.177.383.054c.602.083.906.104 1.56.104a9.91 9.91 0 002.595-.313c1.454-.364 2.767-1.029 3.822-1.935 1.579-1.354 2.455-3.153 2.455-5.036 0-1.694-.7-3.302-2.004-4.599a8.312 8.312 0 00-2.207-1.576C12.489.521 11.373.198 10.026.044A22.61 22.61 0 008.189.007zm.155 1.751c-1.505.095-2.933.554-4.072 1.309-.435.289-.724.53-1.102.92-.747.77-1.203 1.644-1.37 2.629-.05.298-.05.928 0 1.249.085.534.232.99.478 1.488.332.67.759 1.192 1.386 1.698.173.139.288.249.339.325.136.203.205.51.22.987.014.401-.026.704-.14 1.05-.07.213-.221.55-.294.651-.024.035-.038.063-.03.063.007 0 .095-.025.194-.055.713-.218 1.676-.787 2.086-1.234a.84.84 0 01.536-.286c.145-.018.268-.004.637.073.643.136 1.642.193 2.365.137 2.197-.172 4.109-1.08 5.336-2.532.493-.585.89-1.381 1.032-2.078.066-.323.089-.548.089-.903 0-.71-.134-1.28-.453-1.935-.445-.911-1.199-1.72-2.18-2.337-1.002-.63-2.291-1.057-3.577-1.186-.4-.04-1.114-.056-1.48-.033z","fill":"#6E6E6E"}})])
          )
        }
      }
    